fragment SchedulerMeetingChatFragment on Meeting {
    id
    name
    durationMinutes
    primaryHost {
        id
        name
    }
    activityType {
        id
        icon
    }
    lastBookedTime
    validity {
        isBookable
    }
    htmlUrlPath
}
